import { render, staticRenderFns } from "./potree.vue?vue&type=template&id=483fcb08"
import script from "./potree.vue?vue&type=script&lang=js"
export * from "./potree.vue?vue&type=script&lang=js"
import style0 from "./potree.vue?vue&type=style&index=0&id=483fcb08&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports